<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.mobile" max-width="750px" persistent content-class="img-dialog-content">
    <v-card class="dialog-card">
      <div class="imgNum" @click="closeDialog">{{ currentIndex + 1 }} / {{ list.length }}</div>
      <v-btn icon class="close-btn" @click="closeDialog">
        <v-icon color="#fff">mdi-close</v-icon>
      </v-btn>
      <div class="img-area" @click.stop>
        <v-carousel v-model="currentIndex" :height="$vuetify.breakpoint.mobile ? '100%' : '500'" :show-arrows="!$vuetify.breakpoint.mobile && list.length > 1" hide-delimiters>
          <v-carousel-item v-for="(item, i) in list" :key="i">
            <div class="carousel-img-wrapper">
              <v-img lazy-src="/imgs/imgLazy.jpg" class="carousel-img" contain :src="item" alt="detail-item" height="100%" eager />
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'imgDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      currentIndex: 0
    }
  },
  computed: {},
  watch: {
    show(newValue) {
      this.dialog = newValue
      this.currentIndex = this.current
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.img-dialog-content {
  box-shadow: none;
}
.dialog-card {
  background: #1a1a1a !important;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}
.imgNum {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
  color: #fff;
  font-size: 14px;
}
.close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
}
.img-area {
  width: 100%;
}
.carousel-img-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.carousel-img {
  width: 100%;
}
.img-area ::v-deep {
  .v-responsive {
    justify-content: center;
  }
  .v-window-item {
    display: flex;
    align-items: center;
  }
  .v-carousel__item {
    width: 100%;
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 960px) {
  .img-dialog-content {
    box-shadow: none;
  }
  .dialog-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 0;
  }
  .img-area {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
